import ResponsiveHelper from "../utils/ResponsiveHelper";
import GsapScrollUtils from "../utils/GsapScrollUtils";

export default class PagePrivacyPolicy {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
    this.gsu = null;
    this.init();
  }
  async init() {
    this.initResponsiveHelper();
    this.initGsap();
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
    });
  }

  initGsap() {
    this.gsu = new GsapScrollUtils();

    this.gsu.fadeOutOnLeave("[js-anim-fool]", {
      scrub: true,
      markers: false,
      playOnEnterBack: true,
    });

    this.gsu.fadeInOnEnter("[js-anim-fioe]", {
      scrub: true,
      markers: false,
      playOnEnterBack: true,
    });
  }

  setGsapReplay(allow) {
    if (this.gsu && typeof this.gsu.killAll === "function") {
      this.gsu.killAll();
    }
    this.initGsap();
  }

  resize() {
    if (this.gsu) {
      this.gsu.handleResize(() => {
        if (this.threeCanvas && typeof this.threeCanvas.resize === "function") {
          this.threeCanvas.resize();
        }

        // Recreate hero parallax so it uses the updated window height
        if (typeof this.setupHeroParallax === "function") {
          this.setupHeroParallax();
        }
      });
    } else if (
      this.threeCanvas &&
      typeof this.threeCanvas.resize === "function"
    ) {
      this.threeCanvas.resize();
    }
  }
}
